<template>
  <v-dialog v-model="show" scrollable max-width="1200px" persistent>
    <v-card>
      <v-card-title class="grey lighten-3">
        <v-layout align-center>
          <v-icon class="draggable">mdi-drag</v-icon>
          <v-flex sm8 xs12 style="white-space: nowrap">
            {{ dialogTitle }}
          </v-flex>
          <v-flex sm4 xs12>
            <v-tabs v-model="activeTab" right background-color="grey lighten-3">
              <v-tab key="details" @change="checkDuration">Details</v-tab>
              <v-tab key="remarks">Remarks</v-tab>
              <v-tab key="content">Content</v-tab>
            </v-tabs>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-tabs-items v-model="activeTab">
          <v-tab-item key="details">
            <v-row justify-end></v-row>
            <v-card class="px-3 pt-3 mt-3">
              <v-row align="baseline" dense>
                <v-col cols="12" sm="3" class="pb-0">
                  <destination-list-select
                    v-model="selectedDestinationId"
                    :outlined="outlinedInputs"
                    @onSelect="onDestinationChange"
                    hide-not-in-use
                    skip-input
                    :disabled="$apollo.loading"
                  ></destination-list-select>
                </v-col>
                <v-col cols="12" sm="9" class="pb-0">
                  <v-radio-group
                    v-model="selectedSupplierType"
                    row
                    @change="onSupplierTypeChange"
                  >
                    <v-radio
                      v-for="sType in supplierTypes"
                      :key="sType"
                      :label="sType"
                      :value="sType"
                      :disabled="$apollo.loading"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-card>
            <v-card class="px-3 pt-2 mt-2">
              <v-row dense align="center">
                <v-col cols="12" sm="2">
                  <date-picker
                    custom-label="Start Date"
                    :gt-date-string="startDate"
                    :range-start="headerProps ? headerProps.startDate : ''"
                    :range-end="headerProps ? headerProps.endDate : ''"
                    @onDateSelected="onStartDateChange"
                    :outlined="outlinedInputs"
                    :disabled="$apollo.loading"
                  ></date-picker>
                </v-col>
                <v-col cols="12" sm="2">
                  <date-picker
                    custom-label="End Date"
                    :gt-date-string="endDate"
                    :range-start="headerProps ? headerProps.startDate : ''"
                    :range-end="headerProps ? headerProps.endDate : ''"
                    @onDateSelected="onEndDateChange"
                    :outlined="outlinedInputs"
                    :disabled="$apollo.loading"
                  ></date-picker>
                </v-col>

                <v-col cols="12" sm="1">
                  <v-text-field
                    :max="maxAdults"
                    label="Adults"
                    type="number"
                    v-model.number="adults"
                    :outlined="outlinedInputs"
                    @change="onPaxChange"
                    :disabled="$apollo.loading"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="1" v-if="!hideChildren">
                  <v-text-field
                    :max="maxChildren"
                    label="Children"
                    type="number"
                    v-model.number="children"
                    :outlined="outlinedInputs"
                    @change="onPaxChange"
                    :disabled="$apollo.loading"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="1" v-if="!hideChildren">
                  <v-text-field
                    :max="maxInfants"
                    label="Infants"
                    type="number"
                    v-model.number="infants"
                    :outlined="outlinedInputs"
                    @change="onPaxChange"
                    :disabled="$apollo.loading"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="5">
                  <rates-lookback
                    v-if="
                      $store.getters.hasAccessTo('itineraries:look_back', true)
                    "
                    v-model="yearShift"
                    @input="onYearShiftChange"
                    :disabled="$apollo.loading"
                  ></rates-lookback>
                </v-col>
              </v-row>

              <v-row dense align="baseline" class="pb-2">
                <v-col cols="12" sm="4" class="pt-0">
                  <v-autocomplete
                    ref="supplierAutocomplete"
                    label="Supplier"
                    :filter="customSupplierFilter"
                    :items="selectableSuppliers"
                    item-text="node.name"
                    item-value="node"
                    v-model="selectedSupplier"
                    :loading="$apollo.loading"
                    @change="onSupplierChange"
                    @click:clear="onSupplierClear"
                    :search-input.sync="supplierSearch"
                    @keyup.enter="onSupplierKeyEnter"
                    clearable
                    :outlined="outlinedInputs"
                    :disabled="$apollo.loading"
                    hide-details
                  >
                    <template v-slot:prepend-item>
                      <v-list-item
                        v-if="
                          supplierSearch != '' &&
                          supplierSearch != undefined &&
                          allowAdHocSupplier
                        "
                      >
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-btn
                              @click="onSupplierKeyEnter"
                              text
                              color="primary"
                            >
                              <v-icon left>mdi-plus-circle</v-icon>Create: "
                              <strong>{{ supplierSearch }}</strong
                              >"
                            </v-btn>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-avatar size="32">
                        <v-tooltip right v-if="item.node.description">
                          <template v-slot:activator="{ on }">
                            <v-img
                              v-on="on"
                              v-if="item.node.imageURL"
                              :src="item.node.imageURL"
                            ></v-img>
                            <v-icon v-else large v-on="on">
                              mdi-information</v-icon
                            >
                          </template>
                          <v-container style="max-width: 600px">
                            <v-row>
                              <v-col cols="12">
                                <v-img
                                  contain
                                  :src="item.node.imageURL"
                                  max-height="150"
                                ></v-img>
                              </v-col>
                              <v-col cols="12">
                                <div v-html="item.node.description"></div>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-tooltip>
                        <v-icon v-else large> mdi-information</v-icon>
                      </v-list-item-avatar>
                      <template v-if="item.supplierId">
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="
                              `${item.node.supplierName} (${
                                item.node.supplierCode ||
                                (item.node.supplier &&
                                  item.node.supplier.code) ||
                                ''
                              }) ${
                                item.node.headOfficeName != ''
                                  ? `(${item.node.headOfficeName})`
                                  : ''
                              }`
                            "
                          ></v-list-item-title>
                          <v-list-item-subtitle
                            v-html="
                              item.node.priceFrom > 0
                                ? `Price from: ${$options.filters.priceLabeler(
                                    item.node.priceFrom
                                  )}${item.node.priceFromCurrencyCode}`
                                : ''
                            "
                          ></v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                      <template v-else-if="item.node.source">
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="
                              `${item.node.name} (${item.node.locationName})`
                            "
                          ></v-list-item-title>
                          <v-list-item-subtitle
                            v-html="
                              `${item.node.source.name} ${
                                item.node.headOfficeName != ''
                                  ? `(${item.node.headOfficeName})`
                                  : ''
                              }`
                            "
                          ></v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                      <template v-else>
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="`${item.node.name} (${item.node.code})`"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4" class="pt-0">
                  <v-autocomplete
                    ref="serviceAutocomplete"
                    :items="selectableServices"
                    item-text="node.name"
                    item-value="node"
                    label="Service"
                    :loading="$apollo.loading"
                    v-model="selectedService"
                    :search-input.sync="serviceSearch"
                    @keyup.enter="onServiceKeyEnter"
                    clearable
                    :disabled="!selectedSupplier || $apollo.loading"
                    :outlined="outlinedInputs"
                    @change="onSelectedServiceChange"
                    hide-details
                  >
                    <template v-slot:prepend-item>
                      <v-list-item
                        v-if="
                          serviceSearch != '' &&
                          serviceSearch != undefined &&
                          allowAdHocService
                        "
                      >
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-btn
                              @click="onServiceKeyEnter"
                              text
                              color="primary"
                            >
                              <v-icon left>mdi-plus-circle</v-icon>Create: "
                              <strong>{{ serviceSearch }}</strong
                              >"
                            </v-btn>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <template v-slot:item="{ item }">
                      <template v-if="item.node.supplierId">
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="
                              `${item.node.serviceName} (${item.node.service.code})`
                            "
                          ></v-list-item-title>
                          <v-list-item-subtitle
                            v-html="
                              `Price from: ${$options.filters.priceLabeler(
                                item.node.priceFrom
                              )}${item.node.priceFromCurrencyCode} ${
                                item.node.rateTypeCode
                              })`
                            "
                          ></v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn small text icon color="indigo">
                            <v-tooltip>
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on" color="grey lighten-1"
                                  >mdi-information</v-icon
                                >
                              </template>
                              <item-prices-grid
                                :items="[...item.node.prices]"
                              ></item-prices-grid>
                            </v-tooltip>
                          </v-btn>
                        </v-list-item-action>
                      </template>
                      <template v-else>
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="`${item.node.name}`"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <service-status-list-select
                    :service-status-id="statusId"
                    :service-status-name="statusName"
                    @onSelect="onServiceStatusChange"
                    :outlined="outlinedInputs"
                    :isDisabled="false"
                    :disabled="$apollo.loading"
                  ></service-status-list-select>
                </v-col>
                <v-col cols="12" sm="1" class="pt-0">
                  <v-text-field
                    label="Qty"
                    type="number"
                    v-model="qty"
                    @change="onQtyChange"
                    :outlined="outlinedInputs"
                    hide-details
                    :loading="$apollo.loading"
                    :min="1"
                    :disabled="$apollo.loading"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card>

            <v-alert
              :value="yearShift > 0"
              type="warning"
              transition="scale-transition"
              >CAUTION! The rates shown are historical rates are
              {{ yearShift }} year(s) old.</v-alert
            >
            <v-alert
              :value="errorMsg != ''"
              type="error"
              transition="scale-transition"
              >{{ errorMsg }}</v-alert
            >
            <v-alert
              :value="flightErrorMsg != ''"
              type="error"
              transition="scale-transition"
              >{{ flightErrorMsg }}</v-alert
            >
            <v-container class="pb-0 px-0" v-if="serviceNotesStr != ''">
              <v-alert type="info" transition="scale-transition"
                ><div v-html="serviceNotesStr"></div
              ></v-alert>
            </v-container>
            <v-card class="px-3 mt-3">
              <v-row dense>
                <v-col cols="3">
                  <rate-type-list-select
                    :rate-type-code="rateTypeCode"
                    @onSelect="onRateTypeSelect"
                    :outlined="outlinedInputs"
                    hideNotInUse
                    :disabled="$apollo.loading"
                  ></rate-type-list-select>
                </v-col>
                <v-col>
                  <business-model-list-select
                    v-model="businessModel"
                    :outlined="outlinedInputs"
                    :disabled="$apollo.loading"
                  ></business-model-list-select>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Commission"
                    v-model.number="supplierCommission"
                    :outlined="outlinedInputs"
                    :disabled="$apollo.loading || !canEditPrices || !bmUseCommission"
                  ></v-text-field>
                </v-col>
                <v-col cols="2">
                  <currency-list-select
                    v-model="currency"
                    :include-exchange-rate="true"
                    @onSelect="onCurrencySelect"
                    :outlined="outlinedInputs"
                    :enabled="!$apollo.loading && canEditPrices"
                  ></currency-list-select>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    label="Markup %"
                    v-model.number="markup"
                    @change="onMarkupChange"
                    :outlined="outlinedInputs"
                    :disabled="$apollo.loading || !canEditPrices"
                    :hide-details="markupLookupMsg == ''"
                    :messages="markupLookupMsg"
                    :loading="markupLookupLoading"
                  >
                    <template v-slot:append-outer v-if="markupLookupEnabled">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" @click="lookupMarkup">
                            mdi-table-search
                          </v-icon>
                        </template>
                        <span>Lookup markup % from the markup table</span>
                      </v-tooltip>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="3">
                  <v-text-field
                    :disabled="isPerPerson || !isValid || !canEditPrices"
                    name="Item Buy"
                    label="Item Cost"
                    type="number"
                    v-model.number="itemBuy"
                    :outlined="outlinedInputs"
                    @change="onPriceChange(true)"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    :disabled="!isPerPerson || !isValid || !canEditPrices"
                    name="Adult Buy"
                    label="Adult Cost"
                    type="number"
                    v-model.number="adultBuy"
                    :outlined="outlinedInputs"
                    @change="onPriceChange(true)"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    :disabled="
                      !isPerPerson || !isValid || hideChildren || !canEditPrices
                    "
                    name="Child Buy"
                    label="Child Cost"
                    type="number"
                    v-model.number="childBuy"
                    :outlined="outlinedInputs"
                    @change="onPriceChange(true)"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-container py-0>
                    <v-row align="center">
                      <v-text-field
                        :disabled="
                          !isPerPerson ||
                          !isValid ||
                          hideChildren ||
                          !canEditPrices
                        "
                        name="Infant Buy"
                        label="Infant Cost"
                        type="number"
                        v-model.number="infantBuy"
                        :outlined="outlinedInputs"
                        @change="onPriceChange(true)"
                        hide-details=""
                      ></v-text-field>
                      <v-tooltip left>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" color="grey lighten-1" class="pl-1"
                            >mdi-information</v-icon
                          >
                        </template>
                        <v-container>
                          <v-row>
                            Total Cost: &nbsp;
                            <strong>{{ totalBuy }}{{ currency }}</strong>
                            , Base: &nbsp; <strong>{{ totalBuyBase }}</strong>
                          </v-row>
                        </v-container>
                      </v-tooltip>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="3">
                  <v-text-field
                    :disabled="isPerPerson || !isValid || !canEditPrices"
                    name="Item Sell"
                    label="Item Sell"
                    type="number"
                    v-model.number="itemSell"
                    :outlined="outlinedInputs"
                    @change="onPriceChange(false)"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    :disabled="!isPerPerson || !isValid || !canEditPrices"
                    name="Adult Sell"
                    label="Adult Sell"
                    type="number"
                    v-model.number="adultSell"
                    :outlined="outlinedInputs"
                    @change="onPriceChange(false)"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    :disabled="
                      !isPerPerson || !isValid || hideChildren || !canEditPrices
                    "
                    name="Child Sell"
                    label="Child Sell"
                    type="number"
                    v-model.number="childSell"
                    :outlined="outlinedInputs"
                    @change="onPriceChange(false)"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-container py-0>
                    <v-row align="center">
                      <v-text-field
                        :disabled="
                          !isPerPerson ||
                          !isValid ||
                          hideChildren ||
                          !canEditPrices
                        "
                        name="Infant Sell"
                        label="Infant Sell"
                        type="number"
                        v-model.number="infantSell"
                        :outlined="outlinedInputs"
                        @change="onPriceChange(false)"
                        class="py-0 my-0"
                        hide-details
                      ></v-text-field>
                      <v-tooltip left>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" color="grey lighten-1" class="pl-1"
                            >mdi-information</v-icon
                          >
                        </template>
                        <v-container>
                          <v-row>
                            Total Sell:&nbsp;
                            <strong>{{ totalSell }}{{ currency }}</strong>
                            , Base:&nbsp; <strong>{{ totalSellBase }}</strong>
                          </v-row>
                        </v-container>
                      </v-tooltip>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
              <v-row dense v-if="sellCurrencyInfo != ''" justify="end">
                <span class="px-2">{{ sellCurrencyInfo }}</span>
              </v-row>
              <v-row dense align="center" justify="center">
                <v-col cols="12" sm="2">
                  <v-switch
                    label="Custom Pricing"
                    v-model="customPricing"
                    disabled
                  ></v-switch>
                </v-col>
                <v-col cols="2">
                  <v-switch
                    v-model="autoSell"
                    @change="onAutoSellChange"
                    label="Update Sell"
                    :disabled="!canEditPrices"
                  />
                </v-col>
                <v-col class="text-right title grey--text text--darken-2">
                  <template v-if="false">
                    <small>
                      <strong>Total Buy:</strong>
                    </small>
                    {{ totalBuy }},
                    <small>
                      <strong>Base:</strong>
                    </small>
                    {{ totalBuyBase }},
                    <small>
                      <strong>Total Sell:</strong>
                    </small>
                    {{ totalSell }},
                    <small>
                      <strong>Base:</strong>
                    </small>
                    {{ totalSellBase }}
                  </template>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item key="remarks">
            <v-container>
              <item-remarks
                v-model="remarks"
                :service-type="selectedSupplierType"
              />
            </v-container>
          </v-tab-item>
          <v-tab-item key="content">
            <v-card flat>
              <v-card-text class="pa-0">
                <contents
                  v-if="selectedSupplierId != ''"
                  :owner-id="selectedSupplierId"
                ></contents>
                <p v-else class="text-xs-center">Select Supplier First...</p>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <item-linked-services-list
            v-if="serviceLinkedServicesIds.length > 0"
            :services-ids="serviceLinkedServicesIds"
            :start-date="startDate"
            :end-date="endDate"
            :adults="adults"
            :children="children"
            :infants="infants"
            :qty="qty"
            :service-type="selectedSupplierType"
            :department="headerProps ? headerProps.departmentName : ''"
            :agent-id="agentId"
            :destination-id="selectedDestinationId"
            :header-props="headerProps"
            :rate-plan="ratePlan"
            :item-linked-services="linkedServices"
            @save="onLinkedServiceSave"
            :service-id="selectedService ? selectedService.id : ''"
          ></item-linked-services-list>

          <item-extras-list
            class="pt-2"
            :service-id="
              isPricedService
                ? selectedService.serviceId
                : selectedService
                ? selectedService.id
                : ''
            "
            :from="startDate"
            :to="endDate"
            :service-type="selectedSupplierType"
            :agentId="agentId"
            @on-selected-extras-change="onSelectedExtrasChange"
            :extras="extras"
            :adults="adults"
            :children="children"
            :infants="infants"
            :qty="qty"
            :year-shift="yearShift"
          ></item-extras-list>
        </v-tabs-items>
        <div v-if="debug">
          <v-row>
            <v-col>
              <code>{{ rateTypeCode }}</code>
              <code>{{ rateType }}</code>
            </v-col>
          </v-row>
        </div>
      </v-card-text>

      <v-card-actions class="grey lighten-4">
        <h6 class="headline green--text pl-3">
          {{ totalPriceLabel }}
          <v-btn
            v-if="explainer"
            small
            text
            color="green"
            @click="showExplainer = true"
          >
            <v-icon small>mdi-information-outline</v-icon>
          </v-btn>
        </h6>
        <pricing-explainer-dialog
          :show="showExplainer"
          :explainer="explainer"
          @close="showExplainer = false"
        />
        <v-spacer></v-spacer>
        <v-btn @click="$emit('close')" color="warning" text>Cancel</v-btn>
        <v-btn
          :loading="loading"
          :disabled="!isValid"
          color="secondary"
          text
          @click="onAddAndContinue"
          >Add &amp; Continue</v-btn
        >
        <v-btn
          :loading="loading"
          :disabled="!isValid"
          color="secondary"
          text
          @click="onAddAndNextDate"
          >Add &amp; Next Date</v-btn
        >
        <v-btn
          :loading="loading"
          :disabled="!isValid"
          color="primary"
          @click="onAddItem"
          >{{ addLabel }}</v-btn
        >
      </v-card-actions>
      <adhoc-supplier
        :show="showAdhocSupplier"
        :default-supplier-type="selectedSupplierType"
        :default-destination="selectedDestinationId"
        :default-supplier-name="newSupplierName"
        @adhoc-create="onNewSupplierCreate"
        @close="showAdhocSupplier = false"
      ></adhoc-supplier>
      <adhoc-service
        v-model="newService"
        :show="showAdhocService"
        :supplierType="selectedSupplierType"
        @create="onNewServiceCreate"
        @update="onServiceUpdate"
        @close="showAdhocService = false"
      ></adhoc-service>
    </v-card>
  </v-dialog>
</template>

<script>
import { SUPPLIER_TYPES } from "../../../../../constants/supplierTypes";
import { SupplierTypeIconMixin } from "../../../../../mixins/SupplierTypeIconMixin";
import DestinationListSelect from "../../../shared/DestinationListSelect";
import CurrencyListSelect from "../../../shared/CurrencyListSelect";

import DatePicker from "../../../shared/DatePicker";
import RateTypeListSelect from "../../../shared/RateTypeListSelect";
import AdhocSupplier from "../../../shared/AdhocSupplier";
import AdhocService from "../../../shared/AdhocService";
import Contents from "../../../shared/contents/Contents";
import BusinessModelListSelect from "../../../shared/BusinessModelListSelect";
import ItemPricesGrid from "../ItineraryBuilderItemQuickAddItemPricesGrid";
import randomize from "randomatic";
import { BUSINESS_MODELS } from "../graphql";
import { durationInDays } from "@/helpers";
const moment = require("moment");
import {
  SERVICE_TYPES_QUERY,
  CREATE_ADHOC_SERVICE,
  UPDATE_ADHOC_SERVICE,
  CREATE_ADHOC_SUPPLIER,
  AVAILABLE_SUPPLIERS_QUERY,
  GT_CONTENT_HUB_SUPPLIERS,
  GT_CONTENT_HUB_SUPPLIER_DETAILS,
  SERVICE_NOTES,
  SERVICE_INFO,
  SERVICE_MARKUP_QUERY,
} from "./adhoc-item-gql";
import {
  GET_PRICE_BREAKDOWN_QUERY,
  ALL_CURRENCIES_SEARCH_QUERY,
  FLIGHT_LOOKUP,
} from "../../../../../constants/graphql";
import {
  groupByProp,
  removeGQLTypename,
  sortByFn,
  uniqueByProp,
} from "../../../../../helpers";
import ItemExtrasList from "./ItemExtrasList";
import ItemLinkedServicesList from "./ItemLinkedServicesList.vue";
import RatesLookback from "./RatesLookback";
import ItemRemarks from "./ItemRemarks.vue";
import ServiceStatusListSelect from "../../../shared/ServiceStatusListSelect";
import PriceLogMixin from "../mixins/pricing-log";
import PricingExplainerDialog from "./PricingExplainerDialog.vue";

export default {
  name: "AddAdhocItem",

  props: {
    headerProps: {
      type: Object,
      default: null,
    },
    supplierType: {
      type: String,
      default: () => "ACCOMMODATION",
    },
    initialStartDate: {
      type: String,
      default: () => "",
    },
    initialEndDate: {
      type: String,
      default: () => "",
    },
    show: {
      type: Boolean,
      default: () => false,
    },
    supplierName: {
      type: String,
      default: () => "",
    },
    serviceName: {
      type: String,
      default: () => "",
    },
    supplier: {
      type: Object,
      default: () => null,
    },
    service: {
      type: Object,
      default: () => null,
    },
    supplierType: {
      type: String,
      default: () => "ACCOMMODATION",
    },
    editItem: {
      type: Object,
      default: () => null,
    },
    // #11503 remarks for a new item (Analysis tab "Add transfer")
    initialRemarks: {
      type: Object,
      default: () => null,
    },
    destinationId: {
      type: String,
      default: () => "",
    },
  },

  mixins: [SupplierTypeIconMixin, PriceLogMixin],

  components: {
    DestinationListSelect,
    DatePicker,
    RateTypeListSelect,
    CurrencyListSelect,
    AdhocSupplier,
    AdhocService,
    Contents,
    ItemExtrasList,
    ItemLinkedServicesList,
    BusinessModelListSelect,
    RatesLookback,
    ItemPricesGrid,
    ItemRemarks,
    ServiceStatusListSelect,
    PricingExplainerDialog,
  },

  data() {
    return {
      debug: false,
      showExplainer: false,
      yearShift: 0,
      errorMsg: "",
      flightErrorMsg: "",
      sfr: true,
      selectedSupplierType: this.supplierType,
      selectedDestinationId:
        this.destinationId != ""
          ? this.destinationId
          : this.headerProps && this.headerProps.destinationId
          ? this.headerProps.destinationId
          : "",
      startDate:
        this.initialStartDate != ""
          ? this.initialStartDate
          : this.headerProps && this.headerProps.startDate
          ? this.headerProps.startDate
          : "",
      endDate:
        this.initialEndDate != ""
          ? this.initialEndDate
          : this.headerProps && this.headerProps.endDate
          ? this.headerProps.endDate
          : "",
      supplierTypes: SUPPLIER_TYPES,
      selectedSupplier: null,
      selectedService: null,

      maxInfants:
        this.headerProps && this.headerProps.infants
          ? this.headerProps.infants
          : 0,
      adults: this.editItem
        ? this.editItem.adults
        : this.headerProps && this.headerProps.adults
        ? this.headerProps.adults
        : 2,
      children: this.editItem
        ? this.editItem.children
        : this.headerProps && this.headerProps.children
        ? this.headerProps.children
        : 0,
      infants: this.editItem
        ? this.editItem.infants
        : this.headerProps && this.headerProps.infants
        ? this.headerProps.infants
        : 0,
      qty: this.editItem ? this.editItem.qty : 1,
      //#11309 - once the user edits Qty manually, don't let auto-calc (updateQty)
      //clobber it on rate refetches (e.g. lookback toggle re-firing the
      //selectableServices watcher). Reset when supplier/service/pax changes.
      qtyManuallySet: false,
      //#11309 - when the user manually switches lookback OFF, don't let the
      //auto-lookback logic re-arm it (yearShift=1) on the next failed re-price.
      //Reset on a fresh supplier/service context.
      lookbackUserDisabled: false,
      markup: 0,
      markupLookupLoading: false,
      markupLookupMsg: "",
      itemBuy: this.editItem ? this.editItem.pricing.itemBuy : 0,
      adultBuy: this.editItem ? this.editItem.pricing.adultBuy : 0,
      childBuy: this.editItem ? this.editItem.pricing.childBuy : 0,
      infantBuy: this.editItem ? this.editItem.pricing.infantBuy : 0,
      itemSell: this.editItem ? this.editItem.pricing.itemSell : 0,
      adultSell: this.editItem ? this.editItem.pricing.adultSell : 0,
      childSell: this.editItem ? this.editItem.pricing.childSell : 0,
      infantSell: this.editItem ? this.editItem.pricing.infantSell : 0,
      currency: this.editItem ? this.editItem.pricing.currencySell : "",
      currencyBuy: "",
      currencySell: "",
      currencyBuyExRate: 1,
      currencySellExRate: 1,
      rateType: null,
      rateTypeCode: this.editItem ? this.editItem.rateTypeCode : "",
      businessModel: "BM1",
      supplierCommission: 0,
      showAdhocSupplier: false,
      showAdhocService: false,
      loading: false,
      supplierSearch: "",
      initSupplierName: this.supplierName != "" ? this.supplierName : null,
      initServiceName: this.serviceName != "" ? this.serviceName : null,
      serviceSearch: null,
      newSupplierName: "New Supplier",
      newService: null,
      activeTab: 0,
      adhocServiceSupplierId: "",
      dispatchAction: "close",
      supplierNameFilter:
        this.supplierName && this.supplierName != "" ? this.supplierName : null,
      extras: [],
      linkedServices: [],
      customPricing: false,
      searchTimeout: null,
      searchDebounceTime: 700,
      getExternalSupplierDetails: false,
      remarks: this.editItem
        ? {
            pickupPoint: this.editItem.remarks.pickupPoint,
            dropoffPoint: this.editItem.remarks.dropoffPoint,
            pickupTime: this.editItem.remarks.pickupTime,
            dropoffTime: this.editItem.remarks.dropoffTime,
            timeFrom: this.editItem.remarks.timeFrom,
            agentNotes: this.editItem.remarks.agentNotes,
            supplierNotes: this.editItem.remarks.supplierNotes,
            voucherNotes: this.editItem.remarks.voucherNotes,
            internalNotes: this.editItem.remarks.internalNotes,
            flightNo: this.editItem.remarks.flightNo,
            confirmationNo: this.editItem.remarks.confirmationNo,
            roomNumbers: this.editItem.remarks.roomNumbers,
          }
        : { ...(this.initialRemarks || {}) },
      statusId: "",
      statusName: "Quotation",
      autoSell: this.$store.getters.localSettings(
        "pricingEditorAutoSell",
        true
      ),
    };
  },

  computed: {
    formattedStartDate() {
      return new moment(this.startDate).format("YYYY-MM-DDTHH:mm:ss");
    },
    formattedEndDate() {
      return new moment(this.endDate).format("YYYY-MM-DDTHH:mm:ss");
    },
    maxPax() {
      return this.headerProps
        ? Number(this.headerProps.adults) + Number(this.headerProps.children)
        : 10;
    },
    maxAdults() {
      const currentPax = Number(this.adults) + Number(this.children);
      const remaining = this.maxPax - currentPax;
      return Number(this.adults) + remaining;
    },
    maxChildren() {
      const currentPax = Number(this.adults) + Number(this.children);
      const remaining = this.maxPax - currentPax;
      return Number(this.children) + remaining;
    },
    canEditPrices() {
      return this.$store.getters.hasAccessTo("itineraries:edit_prices", true);
    },
    //11058 - markup table lookup available for custom priced adhoc items
    markupLookupEnabled() {
      return (
        this.$store.getters.hasAccessTo("itineraries:markup_lookup") &&
        this.selectedService &&
        this.selectedService.id != "" &&
        this.selectedService.id != null
      );
    },
    bmUseCommission() {
      const bm = this.businessModelsByCode[this.businessModel];
      return bm && bm[0] ? bm[0].commission : false;
    },
    keepCustomPricingForEdit() {
      return !this.$store.getters.hasAccessTo("itineraries:modify_price");
    },
    addLabel() {
      return this.editItem ? "Update" : "Add";
    },
    extrasDiscount() {
      return this.itemPricing && this.itemPricing.extras
        ? this.itemPricing.extras.reduce((d, e) => (d += Number(e.discount)), 0)
        : 0;
    },
    numQty() {
      return Number(this.qty);
    },
    serviceNotesStr() {
      return this.itemPricing && this.itemPricing.serviceNotes
        ? this.itemPricing.serviceNotes.map((sn) => sn.description).join("<br>")
        : this.serviceNotes && this.serviceNotes.edges
        ? this.serviceNotes.edges
            .map(removeGQLTypename)
            .map((sn) => sn.description)
            .join("<br>")
        : "";
    },
    allowAdHocSupplier() {
      return this.$store.getters.hasAccessTo("itineraries:adhoc_items");
    },
    allowAdHocService() {
      return this.$store.getters.hasAccessTo(
        "itineraries:create_adhoc_services"
      );
    },

    hideChildren() {
      return (
        !this.customPricing &&
        this.selectedSupplier &&
        (this.selectedSupplier.extrasChildPrice ||
          (this.selectedSupplier.supplier &&
            this.selectedSupplier.supplier.extrasChildPrice))
      );
    },
    loadTravellandaContent() {
      return this.$store.getters.hasAccessTo("suppliers:travellanda_content");
    },
    businessModelsByCode() {
      return this.businessModels && this.businessModels.edges
        ? groupByProp(this.businessModels.edges.map(removeGQLTypename), "code")
        : {};
    },
    serviceOccupancy() {
      if (
        this.selectedService &&
        this.selectedService.id &&
        this.selectedService.__typename
      ) {
        if (this.selectedService.__typename == "AvailableService") {
          return Number(this.selectedService.service.stdOccupancy);
        } else if (this.selectedService.__typename == "Service") {
          return Number(this.selectedService.service.stdOccupancy);
        } else {
          return Number(this.selectedService.stdOccupancy);
        }
      } else {
        return 1;
      }
    },
    ratePlan() {
      if (
        this.selectedService &&
        this.selectedService.id &&
        this.selectedService.__typename &&
        this.selectedService.__typename == "AvailableService" &&
        this.selectedService.prices &&
        this.selectedService.prices.length > 0 &&
        this.selectedService.prices[0]
      ) {
        return this.selectedService.prices[0].ratePlan != ""
          ? this.selectedService.prices[0].ratePlan
          : null;
      }
      return null;
    },

    selectedExtras() {
      //console.log("updatedExtrasInfo", this.extras, this.itemPricing);
      return [
        ...this.extras.map((e) => {
          if (!e.statusId) {
            e.statusId = "U2VydmljZVN0YXR1cy0x";
            e.status = "Quotation";
          }
          e.isIncluded = true;
          e.isOptional = false;
          const extraPricingInfo = this.itemPricing
            ? this.itemPricing.extras.find((pe) => {
                //console.log("pe", pe);
                const peKey = pe.id.includes(pe.name)
                  ? `${pe.name}:::${pe.id}`
                  : pe.id; //http://tracker.globetrack.ie/issues/6146
                const eKey = e.id.includes(e.name)
                  ? `${e.name}:::${e.id}`
                  : e.id; //http://tracker.globetrack.ie/issues/6146
                //console.log(peKey, eKey);
                return peKey == eKey;
              })
            : undefined;
          //update qty based on rateBase

          return extraPricingInfo
            ? {
                ...e,
                totalSell: extraPricingInfo.totalSell,
                isChildOnly: extraPricingInfo.isChildOnly,
                isInfantOnly: extraPricingInfo.isInfantOnly,
                isMandatory: extraPricingInfo.isMandatory,
                rateTypeCode: extraPricingInfo.rateTypeCode,
                rateBase: extraPricingInfo.rateBase,
                adults: extraPricingInfo.adults,
                children: extraPricingInfo.children,
                infants: extraPricingInfo.infants,
                totalBuy: extraPricingInfo.totalBuy,
                cost: extraPricingInfo.cost,
                sell: extraPricingInfo.sell,
                percentPrice: extraPricingInfo.percentPrice,
                currencyBuyExchangeRate:
                  extraPricingInfo.currencyBuyExchangeRate,
                currencySellExchangeRate:
                  extraPricingInfo.currencySellExchangeRate,
                customPricing: extraPricingInfo.customPricing, // this.customPricing,
                //#11329 the extra's own explainer from this live price build, so the
                //info button is there before the item is recalculated/saved
                explainer: extraPricingInfo.explainer,
                pricing: extraPricingInfo.customPricing //this.customPricing
                  ? {
                      //taken from parent service
                      currency: this.itemPricing.currencyBuy,
                      currencyExchangeRate:
                        this.itemPricing.currencyBuyExchangeRate,
                      cost: extraPricingInfo.cost,
                      sell: extraPricingInfo.sell,
                      rateTypeCode: extraPricingInfo.rateTypeCode,
                    }
                  : undefined,
              }
            : {
                //custom pricing extra
                ...e,
                totalSell:
                  this.safeNumber(e.qty, 0) * this.safeNumber(e.sell, 0),
                adults: e.adults,
                children: e.children,
                infants: e.infants,
                cost: e.buy,
                sell: e.sell,
                customPricing: this.customPricing,
                pricing: this.customPricing
                  ? {
                      //taken from parent service
                      // should be buy currency
                      currency: e.currencyBuy,
                      currencyExchangeRate: e.currencyBuyExchange,
                      cost: e.buy,
                      sell: e.sell,
                      rateTypeCode: e.rateTypeCode,
                    }
                  : undefined,
              };
        }),
      ];
    },
    // Pricing Explainer (#7197) — live getPricing breakdown for the adhoc add flow.
    // Null when the pricing_explainer access setting is off or no explainer exists.
    explainer() {
      return this.itemPricing && this.itemPricing.explainer
        ? this.itemPricing.explainer
        : null;
    },
    totalPriceLabel() {
      return this.customPricing
        ? `Total: ${this.$options.filters.priceLabeler(
            (
              this.safeNumber(this.totalSellBase) *
              this.itineraryAgentCurrencyExRate
            ).toFixed(2)
          )}${this.itineraryAgentCurrency}`
        : this.selectedService && this.itemPricing
        ? `Total: ${this.$options.filters.priceLabeler(
            this.safeNumber(this.itemPricing.totalSell, 0).toFixed(2)
          )}${this.itemPricing.currencySell}${
            (this.itemPricing.discount && this.itemPricing.discount > 0) ||
            this.extrasDiscount > 0
              ? ` - Included Discount: ${
                  this.safeNumber(this.itemPricing.discount || 0) +
                  this.safeNumber(this.extrasDiscount || 0)
                }${this.itemPricing.currencySell}`
              : ""
          }`
        : `Total: ${this.$options.filters.priceLabeler(0)}`;
    },
    isPricedService() {
      return (
        this.selectedService &&
        this.selectedService.__typename == "AvailableService"
      );
    },
    agentId() {
      return this.$store.getters.itineraryAgentId;
    },
    startDateOnly() {
      // Return only the date part (without time) for queries that don't need time
      if (!this.startDate) return "";
      return this.startDate.includes("T")
        ? this.startDate.split("T")[0]
        : this.startDate;
    },
    endDateOnly() {
      // Return only the date part (without time) for queries that don't need time
      if (!this.endDate) return "";
      return this.endDate.includes("T")
        ? this.endDate.split("T")[0]
        : this.endDate;
    },
    sellCurrencyInfo() {
      return this.currencySell != "" &&
        this.itineraryAgentCurrency != this.currencySell
        ? `Your selected sell currency is different than Itinerary's Agent's Currency (${this.itineraryAgentCurrency}). Your sell price will be recalculated to Agent's currency`
        : "";
    },
    itineraryAgentCurrencyExRate() {
      const currency = this.currencies
        ? this.currencies.edges.find(
            (item) => item.node.code == this.itineraryAgentCurrency
          )
        : null;
      const exRate = currency ? currency.node.exchangeRate : 1;
      //console.log("itineraryAgentCurrencyExRate", exRate);
      return this.safeExchangeRate(exRate);
    },
    itineraryAgentCurrency() {
      return this.$store.getters.itineraryAgentCurrency;
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    selectableServices() {
      let list = [];

      if (this.selectedSupplier) {
        // Find the supplier in availableServicesBySupplier
        const supplierFromBySupplier =
          this.availableServicesBySupplier &&
          this.availableServicesBySupplier.edges
            ? this.availableServicesBySupplier.edges.find(
                (item) =>
                  item.node.supplierId ==
                  (this.selectedSupplier.supplierId || this.selectedSupplier.id)
              )
            : null;

        const pricedServices =
          supplierFromBySupplier &&
          supplierFromBySupplier.node.availableServices
            ? supplierFromBySupplier.node.availableServices
                .filter(
                  (service) => service.prices && service.prices.length > 0
                )
                .map((service) => ({
                  node: {
                    ...service,
                    name: service.serviceName,
                    id: service.serviceId,
                    supplierId: service.supplierId,
                    priceFrom: service.priceFrom,
                    priceFromCurrencyCode: service.priceFromCurrencyCode,
                    rateTypeCode: service.rateTypeCode,
                    supplier: {
                      id: service.supplierId,
                      code: supplierFromBySupplier.node.supplierCode,
                      boardBasis: supplierFromBySupplier.node.boardBasis,
                    },
                  },
                }))
            : [];
        // Get unpriced services - those without prices from availableServices, plus from selectedSupplier.services
        const unpricedServicesFromQuery =
          supplierFromBySupplier &&
          supplierFromBySupplier.node.availableServices
            ? supplierFromBySupplier.node.availableServices
                .filter(
                  (service) => !service.prices || service.prices.length === 0
                )
                .map((service) => ({
                  node: {
                    ...service,
                    name: service.serviceName,
                    id: service.serviceId,
                    supplierId: service.supplierId,
                    supplier: {
                      id: service.supplierId,
                      code: supplierFromBySupplier.node.supplierCode,
                      boardBasis: supplierFromBySupplier.node.boardBasis,
                    },
                  },
                }))
            : [];

        const supplierServices = (
          this.selectedSupplier.services
            ? [...this.selectedSupplier.services.edges]
            : []
        ).filter(
          (item) =>
            pricedServices.map((item) => item.node.id).indexOf(item.node.id) ==
              -1 &&
            unpricedServicesFromQuery
              .map((item) => item.node.id)
              .indexOf(item.node.id) == -1
        );

        // Combine all unpriced services
        const allUnpricedServices = [
          ...unpricedServicesFromQuery,
          ...supplierServices,
        ];
        list = [
          ...(pricedServices.length
            ? [
                { header: `Priced Services` },
                ...pricedServices,
                { divider: true },
              ]
            : []),
          ...(allUnpricedServices.length
            ? [
                { header: `Unpriced Supplier's Services` },
                ...allUnpricedServices.sort(
                  sortByFn((item) => item.node.name.toString())
                ),
                { divider: true },
              ]
            : []),
        ];
      }
      // Always add Admin's Services if user has access, regardless of supplier selection
      if (
        this.$store.getters.hasAccessTo("itineraries:create_adhoc_services") &&
        this.serviceTypes &&
        this.serviceTypes.edges
      ) {
        list = [
          ...list,
          { header: `Admin's Services` },
          ...this.serviceTypes.edges
            .filter((item) => !item.node.notInUse)
            .map((item) => ({
              node: { ...item.node },
            })),
        ];
      }
      return list;
    },
    selectableSuppliers() {
      // Get all suppliers from availableServicesBySupplier (both priced and unpriced)
      const allSuppliersFromQuery =
        this.availableServicesBySupplier &&
        this.availableServicesBySupplier.edges &&
        this.sfr
          ? this.availableServicesBySupplier.edges.map((item) => ({
              node: {
                ...item.node,
                name: item.node.supplierName,
                imageURL: item.node.imageURL,
                description: item.node.description,
                id: item.node.id,
                supplierCode: item.node.supplierCode,
                boardBasis: item.node.boardBasis,
                priceFrom: item.node.priceFrom,
                priceFromCurrencyCode: item.node.priceFromCurrencyCode,
                serviceType: item.node.serviceType,
                currencyCode: item.node.currencyCode,
                defaultRateTypeCode: item.node.defaultRateTypeCode,
                extrasChildPrice: item.node.extrasChildPrice,
                availableServices: item.node.availableServices || [],
              },
              supplierId: item.node.id,
            }))
          : [];

      // Separate priced (have services with prices) and unpriced (no services with prices)
      const priced = allSuppliersFromQuery.filter((item) => {
        if (
          !item.node.availableServices ||
          item.node.availableServices.length === 0
        ) {
          return false;
        }
        // Check if at least one service has prices
        return item.node.availableServices.some(
          (service) => service.prices && service.prices.length > 0
        );
      });

      // Get unpriced suppliers (no services with prices)
      const unpriced = allSuppliersFromQuery.filter((item) => {
        if (
          !item.node.availableServices ||
          item.node.availableServices.length === 0
        ) {
          return true;
        }
        // Check if all services have empty prices arrays
        return !item.node.availableServices.some(
          (service) => service.prices && service.prices.length > 0
        );
      });
      //external
      const external = this.externalSuppliers
        ? this.externalSuppliers.map((supplier) => ({
            node: { ...supplier },
          }))
        : [];
      return [
        ...priced,
        { header: `Unpriced Suppliers (${unpriced.length})` },
        { divider: true },
        ...unpriced,
        { header: `External Suppliers (${external.length})` },
        { divider: true },
        ...external,
      ];
    },
    isPerPerson() {
      return this.rateType ? this.rateType.includePax : false;
    },
    dialogTitle() {
      return this.selectedSupplier && this.selectedService
        ? `${this.selectedSupplier.name} - ${
            this.selectedService.name
          } (From: ${this.$options.filters.formatDate(
            this.startDate
          )}, to: ${this.$options.filters.formatDate(this.endDate)})`
        : "Adding Item (v2)";
    },
    itineraryItem() {
      if (!this.selectedService) {
        return {};
      }
      const bm = this.businessModelsByCode[this.businessModel]
        ? this.businessModelsByCode[this.businessModel][0]
        : false;
      const pricing = {
        adultBuy: this.safeNumber(this.adultBuy),
        adultSell: this.safeNumber(this.toAgentCurrency(this.adultSell)),
        childBuy: this.safeNumber(this.childBuy),
        childSell: this.safeNumber(this.toAgentCurrency(this.childSell)),
        infantBuy: this.safeNumber(this.infantBuy),
        infantSell: this.safeNumber(this.toAgentCurrency(this.infantSell)),
        itemBuy: this.safeNumber(this.itemBuy),
        itemSell: this.safeNumber(this.toAgentCurrency(this.itemSell)),
        rateTypeCode: this.rateType ? this.rateType.code : "",
        currencyBuy: this.currencyBuy || "",
        currencyBuyExchangeRate: this.safeExchangeRate(this.currencyBuyExRate),
        currencySell: this.itineraryAgentCurrency || "",
        currencySellExchangeRate: this.safeExchangeRate(
          this.itineraryAgentCurrencyExRate
        ),
        discountCost: this.safeNumber(
          this.itemPricing && this.itemPricing.discountCost
            ? this.itemPricing.discountCost
            : 0
        ),
        discountSell: this.safeNumber(
          this.itemPricing && this.itemPricing.discountSell
            ? this.itemPricing.discountSell
            : 0
        ),
      };
      if (this.customPricing) {
        pricing.logs = [this.getLog({ pricing: { ...pricing } })];
      }

      const item = {
        id:
          this.editItem && this.editItem.id
            ? this.editItem.id
            : randomize("Aa0", 32),
        serviceName: this.selectedService
          ? this.selectedService.name
          : "New Service",
        supplierName: this.selectedSupplier
          ? this.selectedSupplier.name
          : "New Supplier",
        supplierId: this.selectedSupplier
          ? this.selectedSupplier.supplier
            ? this.selectedSupplier.supplier.id
            : this.selectedSupplier.id
          : undefined,
        startDate: this.startDate,
        endDate: this.endDate,
        price: this.customPricing
          ? this.safeNumber(this.toAgentCurrency(this.totalSell))
          : this.itemPricing
          ? this.safeNumber(this.itemPricing.serviceSell)
          : 0,
        status: this.statusName,
        statusId: this.statusId != "" ? this.statusId : "U2VydmljZVN0YXR1cy0x",
        adults: this.adults,
        children: this.hideChildren ? 0 : this.children,
        infants: this.hideChildren ? 0 : this.infants,
        qty: this.qty == 0 ? 1 : this.qty,
        stdOccupancy: this.serviceOccupancy,
        rateTypeCode: this.customPricing
          ? this.rateType
            ? this.rateType.code
            : ""
          : this.selectedService.rateTypeCode,
        ratePlan: this.ratePlan,
        serviceType: this.selectedSupplierType,
        selected: false,
        customPricing: this.customPricing || this.yearShift != 0,
        isOptional: bm ? bm.setAsOptional : false,
        isIncluded: bm ? bm.includesFlagOn : true,
        isHidden: this.serviceInfo ? this.serviceInfo.noReport : false,
        includeCommission: this.serviceInfo
          ? !this.serviceInfo.skipAgentCommission
          : true,
        businessModel: this.businessModel,
        boardBasis: this.selectedService.supplier
          ? this.selectedService.supplier.boardBasis
          : this.selectedSupplier && this.selectedSupplier.boardBasis
          ? this.selectedSupplier.boardBasis
          : this.selectedSupplier &&
            this.selectedSupplier.supplier &&
            this.selectedSupplier.supplier.boardBasis
          ? this.selectedSupplier.supplier.boardBasis
          : "",
        supplierCommission: this.safeNumber(this.supplierCommission),
        remarks: {
          ...this.remarks,
          supplierNotes:
            //kbz why need it?
            //removed at  18/12/2023 -> https://tracker.globetrack.ie/issues/8875
            // probably this condition need to be more specific
            this.error != "" && this.errorMsg != "" && false
              ? `CAUTION! Service is usually ${this.errorMsg}`
              : "",
        },
        supplierComp: 0,
        passComp: 0,
        pricing,
        extras:
          this.selectedExtras.length > 0 ? [...this.selectedExtras] : undefined,
        yearShift: this.yearShift != 0 ? this.yearShift : undefined,
      };
      //set proper service id
      //console.log("selected service", this.selectedService);
      item.serviceId =
        this.selectedService && this.selectedService.id
          ? this.selectedService.id
          : "";
      if (
        this.serviceNotesStr != "" &&
        !this.$store.getters.hasAccessTo("itineraries:hide_notes_from_remarks")
      ) {
        item.remarks.agentNotes = this.serviceNotesStr.replace("<br>", "\n");
      }

      // Process linked services after item is created
      if (this.linkedServices.length > 0) {
        item.linkedServices = this.linkedServices.map((linkedService) => ({
          parentId: item.id,
          ...linkedService,
        }));
      }

      //console.log("itineraryItem", item);
      return item;
    },
    isValid() {
      return this.selectedSupplier &&
        this.selectedService &&
        this.itineraryItem.serviceId != "" &&
        this.itineraryItem.pricing.currencySell != "" &&
        this.itineraryItem.startDate != "" &&
        this.itineraryItem.endDate != "" &&
        this.itineraryItem.pricing.currencyBuy != "" &&
        this.itineraryItem.pricing.currencySell != ""
        ? true
        : false;
    },
    totalBuy() {
      return this.getTotalFunction("Buy")();
    },
    totalBuyBase() {
      const totalBuyBase = this.getTotalFunction("Buy")();
      const exRate = this.safeExchangeRate(this.currencyBuyExRate);
      return (this.safeNumber(totalBuyBase) / exRate).toFixed(2);
    },
    totalSell() {
      return this.getTotalFunction("Sell")();
    },
    totalSellBase() {
      const totalSellBase = this.getTotalFunction("Sell")();
      const exRate = this.safeExchangeRate(this.currencySellExRate);
      return (this.safeNumber(totalSellBase) / exRate).toFixed(2);
    },
    selectedSupplierId() {
      return this.selectedSupplier
        ? this.selectedSupplier.supplierId
          ? this.selectedSupplier.supplierId
          : this.selectedSupplier.id
        : "";
    },
    serviceLinkedServicesIds() {
      return this.serviceInfo && this.serviceInfo.linkedServices
        ? this.serviceInfo.linkedServices.edges.map((e) => e.node.id)
        : [];
    },
  },

  watch: {
    destinationId(newVal) {
      if (newVal != "") {
        this.selectedDestinationId = newVal;
      }
    },
    selectableServices(newList) {
      if (newList) {
        if (this.service) {
          const preSelectedService = newList.find((item) =>
            item.node ? item.node.id == this.service.id : false
          );

          if (preSelectedService) {
            this.selectedService = { ...preSelectedService.node };
            this.updateQty();
          }
        } else {
          this.setSelectedService();
        }
      }
    },

    selectableSuppliers(newList) {
      if (newList) {
        let supplierId = this.selectedSupplierId;
        if (this.supplier) {
          supplierId = this.supplier.id;
        }
        if (supplierId != "") {
          const preSelectedSupplier = newList.find(
            (item) =>
              (item.node && item.node.supplierId == supplierId) ||
              (item.supplierId && item.supplierId == supplierId)
          );
          if (preSelectedSupplier) {
            this.selectedSupplier = { ...preSelectedSupplier.node };
            this.onSupplierChange(this.selectedSupplier);
          }
        }
      }
    },

    supplierSearch(newVal) {
      clearTimeout(this.searchTimeout);
      if (!this.selectedSupplier) {
        this.searchTimeout = setTimeout(() => {
          // Only update supplierNameFilter if search has a value, or if supplierName prop is not set
          // This preserves the initial supplierName prop value
          if (newVal && newVal != "") {
            this.supplierNameFilter = newVal;
          } else if (!this.supplierName || this.supplierName == "") {
            this.supplierNameFilter = null;
          }
        }, this.searchDebounceTime);
      }
    },
    headerProps(newProps) {
      this.selectedDestinationId = newProps.destinationId;
      this.startDate = newProps.startDate;
      this.endDate = newProps.endDate;
      this.adults = newProps.adults;
      this.children = newProps.children;
      this.infants = newProps.infants;
      this.maxInfants = newProps.infants;
    },
    show() {
      //reset
      this.selectedService = null;
      this.activeTab = 0;
    },
    supplierType(newVal) {
      this.selectedSupplierType = newVal;
    },
    supplierName(newVal) {
      if (newVal && newVal != "") {
        this.supplierNameFilter = newVal;
      }
    },

    serviceName(newVal) {
      //this.initServiceName = newVal;
      // if (this.$refs.serviceAutocomplete) {
      //   this.setInitialServiceName();
      // }
    },
    initialStartDate(newVal) {
      this.startDate = newVal;
    },
    initialEndDate(newVal) {
      this.endDate = newVal;
    },
  },

  methods: {
    // Helper method to safely convert values to numbers, defaulting to 0 for invalid values
    safeNumber(value, defaultValue = 0) {
      if (value === null || value === undefined || value === "") {
        return defaultValue;
      }
      const num = Number(value);
      return isNaN(num) || !isFinite(num) ? defaultValue : num;
    },
    // Helper method to safely convert exchange rates, defaulting to 1 for invalid values
    safeExchangeRate(value) {
      if (value === null || value === undefined || value === "") {
        return 1;
      }
      const num = Number(value);
      return isNaN(num) || !isFinite(num) || num <= 0 ? 1 : num;
    },
    onDestinationChange(payload) {
      if (this.editItem == null) {
        this.resetAll();
      } else {
        //reset supplier
        this.resetSupplierAndService();
        if (this.supplierNameFilter) {
          this.supplierNameFilter = null;
        }
      }
      this.selectedDestinationId = payload.id;
    },
    onYearShiftChange() {
      //refresh extras
      this.extras = [];
      //#11309 - remember an explicit user OFF so auto-lookback won't re-enable it
      this.lookbackUserDisabled = Number(this.yearShift) === 0;
    },
    onSelectedExtrasChange(payload) {
      //console.log("onSelectedExtrasChange", payload);
      this.extras = [...payload];
    },
    onLinkedServiceSave(item) {
      //console.log("onLinkedServiceSave", item);
      //check if item is already in linkedServices
      const index = this.linkedServices.findIndex(
        (service) => service.serviceId === item.serviceId
      );
      if (index > -1) {
        this.linkedServices[index] = { ...item };
      } else {
        this.linkedServices.push(item);
      }
    },
    handlePricingMessage() {
      this.errorMsg = this.itemPricing.message;
    },
    onAutoSellChange() {
      this.$store.dispatch("updateLocalSettings", {
        pricingEditorAutoSell: this.autoSell,
      });
    },
    addTimeToDates(pickupTime, dropoffTime) {
      const [ph, pm] = pickupTime.split(":");
      const [dh, dm] = dropoffTime.split(":");
      this.startDate = moment(this.startDate)
        //.utcOffset(0, true)
        .hour(ph)
        .minute(pm)
        .toISOString(true);
      this.endDate = moment(this.endDate).hour(dh).minute(dm).toISOString(true);
    },
    checkDuration() {
      //http://tracker.globetrack.ie/issues/5905
      // only if both times are set
      if (
        this.remarks &&
        this.remarks.pickupTime &&
        this.remarks.pickupTime != "" &&
        this.remarks.dropoffTime &&
        this.remarks.dropoffTime != ""
      ) {
        const pickupTime =
          this.remarks.pickupTime && this.remarks.pickupTime != ""
            ? this.remarks.pickupTime
            : "00:00";
        const dropoffTime =
          this.remarks.dropoffTime && this.remarks.dropoffTime != ""
            ? this.remarks.dropoffTime
            : "00:01";
        const dateContainsTime = this.startDate.includes("T"); //https://tracker.globetrack.ie/issues/8977#change-39724
        if (this.selectedSupplierType == "TRANSPORT" && !dateContainsTime) {
          this.addTimeToDates(pickupTime, dropoffTime);
        }
      } else {
        this.addTimeToDates("00:00", "00:01");
      }
    },
    customSupplierFilter(item, queryText, itemText) {
      return true;
      if (queryText && item.node && item.node.supplier) {
        const qs = queryText.toString().toLowerCase();
        const ns = item.node.name.toString().toLowerCase();
        const cs = item.node.supplier.code.toString().toLowerCase();
        //console.log("customSupplierFilter",qs, ns, cs);
        return cs.includes(qs) || ns.includes(qs);
      } else {
        //console.log("item.node",item.node);
        return false;
      }
    },
    onServiceStatusChange(s) {
      this.statusId = s.id;
      this.statusName = s.name;
    },
    onSupplierClear() {
      this.selectedSupplier = null;
      this.selectedService = null;
      if (this.supplier) {
        this.$emit("clear", null);
      } else {
        this.resetAll();
      }
    },
    resetInputs() {
      //console.log("resetting", this.isPerPerson);
      if (this.isPerPerson) {
        // Clear per-item fields and ensure they're 0, not undefined
        this.itemBuy = 0;
        this.itemSell = 0;
      } else {
        // Clear per-person fields and ensure they're 0, not undefined
        for (const paxType of ["adult", "child", "infant"]) {
          for (const priceType of ["Buy", "Sell", "SellISC"]) {
            const fieldName = paxType + priceType;
            this[fieldName] = 0;
          }
        }
      }
    },
    onMarkupChange(event) {
      if (!isNaN(event)) {
        this.updatePrices();
        this.customPricing = true;
      }
    },
    //11058 - lookup markup % from the markup table rules
    lookupMarkup() {
      this.markupLookupMsg = "";
      this.markupLookupLoading = true;
      this.$apollo
        .query({
          query: SERVICE_MARKUP_QUERY,
          fetchPolicy: "network-only",
          variables: {
            serviceId: this.selectedService.id,
            date: this.formattedStartDate,
            agentId: this.agentId || null,
            department: this.headerProps
              ? this.headerProps.departmentName
              : null,
            itineraryCreationDate: this.headerProps
              ? this.headerProps.createdAt
              : null,
          },
        })
        .then(({ data }) => {
          this.markupLookupLoading = false;
          if (data.serviceMarkup != null) {
            this.markup = data.serviceMarkup;
            this.onMarkupChange(this.markup);
          } else {
            this.markupLookupMsg = "No markup rule found";
          }
        })
        .catch(() => {
          this.markupLookupLoading = false;
          this.markupLookupMsg = "Markup lookup failed";
        });
    },
    updatePrices() {
      if (this.autoSell) {
        const markup = this.safeNumber(this.markup, 0) / 100;
        if (this.isPerPerson) {
          for (const priceType of ["adult", "child", "infant"]) {
            const cost = this.safeNumber(this[`${priceType}Buy`]);
            this[`${priceType}Sell`] = cost + cost * markup;
          }
        } else {
          const cost = this.safeNumber(this["itemBuy"]);
          this[`itemSell`] = cost + cost * markup;
        }
      }
    },
    toAgentCurrency(amount) {
      const safeAmount = this.safeNumber(amount, 0);
      const sellExRate = this.safeExchangeRate(this.currencySellExRate);
      const agentExRate = this.safeExchangeRate(
        this.itineraryAgentCurrencyExRate
      );
      return (safeAmount / sellExRate) * agentExRate;
    },
    onPaxChange() {
      //this.resetAll();
      //#11309 - pax changed => recompute qty from occupancy afresh
      this.qtyManuallySet = false;
      this.updateQty();
    },
    onSupplierChange(event) {
      if (event) {
        const supplier = event.supplier ? { ...event.supplier } : { ...event };
        if (supplier.currencyCode && supplier.currencyCode.toString() != "") {
          this.currencySell = supplier.currencyCode.toString();
          this.currencyBuy = supplier.currencyCode.toString();
          this.currency = supplier.currencyCode.toString();
          // take it from currencies
          const currency = this.currencies
            ? this.currencies.edges.find(
                (item) => item.node.code == supplier.currencyCode.toString()
              )
            : null;
          const exRate = currency ? currency.node.exchangeRate : 1;
          this.currencyExchangeRate = this.safeExchangeRate(exRate);
          this.currencyBuyExRate = this.safeExchangeRate(exRate);
          this.currencySellExRate = this.safeExchangeRate(exRate);
        }
        if (
          supplier.defaultRateTypeCode &&
          supplier.defaultRateTypeCode.toString() != "" &&
          (supplier.supplierId != this.selectedSupplierId ||
            this.rateTypeCode == "")
        ) {
          this.rateTypeCode = supplier.defaultRateTypeCode;
        }
        //this.resetPricing();
      }
    },
    onPriceChange(isCost) {
      if (isCost) {
        this.updatePrices();
      } else {
        const markup = this.isPerPerson
          ? (() => {
              const adultSell = this.safeNumber(this.adultSell);
              const adultBuy = this.safeNumber(this.adultBuy);
              if (adultBuy === 0) return 0;
              return ((adultSell - adultBuy) / adultBuy) * 100;
            })()
          : (() => {
              const itemSell = this.safeNumber(this.itemSell);
              const itemBuy = this.safeNumber(this.itemBuy);
              if (itemBuy === 0) return 0;
              return ((itemSell - itemBuy) / itemBuy) * 100;
            })();
        this.markup = isFinite(markup) ? Number(markup.toFixed(2)) : 0;
      }

      this.customPricing = true;
    },
    resetPricing() {
      //console.log("reseting");
      this.adultBuy = 0;
      this.adultSell = 0;
      this.childBuy = 0;
      this.childSell = 0;
      this.infantBuy = 0;
      this.infantSell = 0;
      this.itemBuy = 0;
      this.itemSell = 0;
    },
    resetSupplierAndService() {
      this.selectedSupplier = null;
      this.selectedService = null;
    },
    onSupplierTypeChange() {
      this.resetAll();
      //set end date for non accommodation
      if (this.selectedSupplierType == "ACCOMMODATION") {
        if (this.headerProps && this.headerProps.endDate) {
          this.endDate = this.headerProps.endDate;
        }
      } else {
        this.endDate = this.startDate;
      }
    },
    resetAll() {
      this.resetPricing();
      this.resetSupplierAndService();
      this.markup = 0;
      this.currencyBuy = "";
      this.currencySell = "";
      this.rateTypeCode = "";
      //#11309 - fresh supplier/service context => allow qty auto-calc again
      this.qtyManuallySet = false;
      //#11309 - and let auto-lookback re-arm for the new selection
      this.lookbackUserDisabled = false;
      //console.log("resetAll");
    },
    onSelectedServiceChange(change) {
      if (
        this.selectedService &&
        this.selectedService.__typename == "ServiceType"
      ) {
        this.customPricing = true;
      }
      // } else {
      //   this.customPricing = false;
      // }
      //update qty
      //#11309 - a different service was picked => recompute qty from occupancy
      this.qtyManuallySet = false;
      this.updateQty();
    },
    onQtyChange() {
      //#11309 - user edited Qty by hand; keep it sticky against auto-recalc
      this.qtyManuallySet = true;
    },
    updateQty() {
      //#11309 - respect a manually-set Qty; don't overwrite it on rate refetches
      if (this.qtyManuallySet) return;
      // if (this.adults > this.maxAdults) this.adults = this.maxAdults;
      // if (this.children > this.maxChildren) this.children = this.maxChildren;
      // if (this.infants > this.maxInfants) this.infants = this.maxInfants;
      const pax = this.hideChildren
        ? Number(this.adults)
        : Number(this.adults) + Number(this.children);
      this.qty = Math.ceil(pax / this.serviceOccupancy);
    },
    onCurrencySelect(event) {
      this.currencyBuy = event.code;
      this.currencyBuyExRate = this.safeExchangeRate(event.exchangeRate);
      this.currencySell = event.code;
      this.currencySellExRate = this.safeExchangeRate(event.exchangeRate);
      this.customPricing = true;
    },
    onBuyCurrencySelect(event) {
      this.currencyBuy = event.code;
      this.currencyBuyExRate = this.safeExchangeRate(event.exchangeRate);
      this.customPricing = true;
    },
    onSellCurrencySelect(event) {
      this.currencySell = event.code;
      this.currencySellExRate = this.safeExchangeRate(event.exchangeRate);
      this.customPricing = true;
    },
    validateDateRange(startDate, endDate) {
      return Math.abs(moment(startDate).diff(moment(endDate), "d")) <= 99;
    },
    onStartDateChange(event) {
      if (!this.validateDateRange(event, this.endDate)) {
        alert("Please check your dates, selected date range is too long.");
        return false;
      }
      this.startDate = event;
      if (moment(this.startDate) > moment(this.endDate)) {
        if (this.selectedSupplierType == "ACCOMMODATION") {
          const newEndDate = moment(this.startDate).add(1, "day");
          if (moment(this.headerProps.endDate) > newEndDate) {
            this.endDate = newEndDate.toISOString(true);
          } else {
            this.endDate = this.headerProps.endDate;
          }
        } else {
          this.endDate = this.startDate;
        }
      }
    },
    onEndDateChange(event) {
      if (!this.validateDateRange(this.startDate, event)) {
        alert("Please check your dates, selected date range is too long.");
        return false;
      }
      this.endDate = event;
      if (moment(this.endDate) < moment(this.startDate)) {
        if (this.selectedSupplierType == "ACCOMMODATION") {
          const newStartDate = moment(this.endDate).subtract(1, "day");
          if (moment(this.headerProps.startDate) < newStartDate) {
            this.startDate = newStartDate.toISOString(true);
          } else {
            this.startDate = this.headerProps.startDate;
          }
        } else {
          this.startDate = this.endDate;
        }
      }
    },
    onRateTypeSelect(event) {
      this.rateType = { ...event };

      this.resetInputs();
    },
    onAddItem(event) {
      this.dispatchOrCreate("close");
    },
    onAddAndContinue(event) {
      this.dispatchOrCreate("continue");
    },
    onAddAndNextDate(event) {
      this.dispatchOrCreate("next_date");
      //set next date
    },
    dispatchOrCreate(action) {
      this.dispatchAction = action;
      //check if it's existing service
      if (this.selectedSupplier.source) {
        this.createSupplierFromExternalSource();
      } else {
        if (this.selectedService.__typename == "ServiceType") {
          //need to create service
          this.createNewService();
        } else {
          this.dispatchAdhocAdd();
        }
      }
    },
    dispatchAdhocAdd() {
      //console.log(this.itineraryItem);
      this.$emit("adhoc-add", {
        data: { ...this.itineraryItem },
        action: this.dispatchAction,
      });
      //do post action stuff
      this.doPostActionStuff();
    },
    doPostActionStuff() {
      //reset selected extras
      this.extras = [];
      if (this.dispatchAction == "continue") {
        //reset supplier
        //this.selectedSupplier = null;
      }
      if (this.dispatchAction == "next_date") {
        this.selectedSupplier = null;
        const newStartDate =
          this.selectedSupplierType == "ACCOMMODATION"
            ? moment(this.endDate)
            : moment(this.startDate).add(1, "day");

        const defaulDuration =
          this.selectedSupplierType == "ACCOMMODATION" ? 1 : 0;
        const newEndDate = moment(newStartDate).add(defaulDuration, "day");

        if (newStartDate <= moment(this.headerProps.endDate)) {
          this.startDate = newStartDate.toISOString(true);
        }
        if (newEndDate <= moment(this.headerProps.endDate)) {
          this.endDate = newEndDate.toISOString(true);
        } else {
          this.endDate = this.headerProps.endDate;
        }
        // const newStartDate = moment(this.endDate).add(1, "day");
        // const newEndDate = moment(newStartDate).add(1, "day");
        // this.startDate = newStartDate.toISOString(true);
        // if (newEndDate > moment(this.headerProps.endDate)) {
        //   this.endDate = this.headerProps.endDate;
        // } else {
        //   this.endDate = newEndDate.toISOString(true);
        // }
      }
    },
    onServiceUpdate(payload) {
      this.loading = true;
      const { id, ...serviceInput } = payload;
      this.$apollo
        .mutate({
          mutation: UPDATE_ADHOC_SERVICE,
          variables: {
            serviceId: id,
            serviceInput,
          },
        })
        .then(({ data }) => {
          //console.log("update complete", data);
          this.selectedService = { ...data.updateService };
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
        });
    },
    createNewService() {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: CREATE_ADHOC_SERVICE,
          variables: {
            supplierId: this.selectedSupplier.supplierId
              ? this.selectedSupplier.supplierId
              : this.selectedSupplier.id,
            serviceInput: {
              name: this.selectedService.name,
              typeName: this.selectedService.name,
              stdOccupancy: this.selectedService.stdOccupancy,
              minOccupancy: this.selectedService.minOccupancy,
              maxOccupancy: this.selectedService.maxOccupancy,
              notInUse: false,
            },
          },
        })
        .then(({ data }) => {
          this.selectedService.id = data.createService.id;
          this.loading = false;
          //this.$emit("adhoc-add", { ...this.itineraryItem });
          this.dispatchAdhocAdd();
        })
        .catch((err) => {
          console.error(err);
          this.loading = false;
        });
    },
    getTotalFunction(type) {
      const totalFunction = () => {
        let total = 0;

        if (this.isPerPerson) {
          const adultPrice = this.safeNumber(this[`adult${type}`]);
          const childPrice = this.safeNumber(this[`child${type}`]);
          const infantPrice = this.safeNumber(this[`infant${type}`]);
          const adults = this.safeNumber(this.adults);
          const children = this.safeNumber(this.children);
          const infants = this.safeNumber(this.infants);

          total =
            adults * adultPrice + children * childPrice + infants * infantPrice;
        } else {
          const itemPrice = this.safeNumber(this[`item${type}`]);
          const qty = this.safeNumber(this.qty, 1);
          total = qty * itemPrice;
        }

        if (this.rateType && this.rateType.includeDays) {
          let duration = this.safeNumber(
            durationInDays(this.startDate, this.endDate),
            1
          );
          if (["ACCOMMODATION"].indexOf(this.selectedSupplierType) == -1) {
            duration++;
          }
          if (duration == 0) {
            duration = 1;
          }
          if (
            duration > 1 &&
            this.selectedSupplierType == "TRANSPORT" &&
            this.remarks &&
            this.remarks.pickupTime &&
            this.remarks.dropoffTime
          ) {
            const start = parseInt(
              this.remarks.pickupTime.toString().replace(":", "")
            );
            const end = parseInt(
              this.remarks.dropoffTime.toString().replace(":", "")
            );
            if (end <= start) {
              duration--;
            }
          }

          total = total * duration;
        }

        // Ensure we never return NaN
        return this.safeNumber(total);
      };
      return totalFunction;
    },
    onNewServiceCreate(payload) {
      //this.showAdhocService = false;
      this.adhocServiceSupplierId = this.selectedSupplierId;
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: CREATE_ADHOC_SERVICE,
          variables: {
            supplierId: this.selectedSupplier.supplierId
              ? this.selectedSupplier.supplierId
              : this.selectedSupplier.id,
            serviceInput: payload,
          },
          update: (store, { data: { createService } }) => {
            const supplierId = this.selectedSupplier.supplierId
              ? this.selectedSupplier.supplierId
              : this.selectedSupplier.id;

            // Try to update AVAILABLE_SUPPLIERS_QUERY cache
            try {
              const availableSuppliersData = store.readQuery({
                query: AVAILABLE_SUPPLIERS_QUERY,
                variables: this.availableSuppliersQueryVars(),
              });

              if (
                availableSuppliersData &&
                availableSuppliersData.availableServicesBySupplier
              ) {
                const supplierEdge =
                  availableSuppliersData.availableServicesBySupplier.edges.find(
                    (item) =>
                      item.node.supplierId == supplierId ||
                      item.node.id == supplierId
                  );

                if (supplierEdge && supplierEdge.node.availableServices) {
                  // Add the new service with full shape to match query and avoid Apollo "Missing field" warnings
                  const supplierName =
                    supplierEdge.node.supplierName ||
                    this.selectedSupplier.supplierName ||
                    "";
                  const newService = {
                    __typename: "Service",
                    id: createService.id,
                    serviceName: createService.name,
                    serviceId: createService.id,
                    supplierName,
                    supplierId,
                    priceFrom: null,
                    priceFromCurrencyCode: null,
                    rateTypeCode: null,
                    stdOccupancy:
                      createService.stdOccupancy != null
                        ? createService.stdOccupancy
                        : null,
                    service: {
                      __typename: "ServiceType",
                      stdOccupancy:
                        createService.stdOccupancy != null
                          ? createService.stdOccupancy
                          : null,
                      code: null,
                      imageURL: null,
                      description: null,
                    },
                    prices: [],
                  };
                  supplierEdge.node.availableServices.push(newService);
                  store.writeQuery({
                    query: AVAILABLE_SUPPLIERS_QUERY,
                    variables: this.availableSuppliersQueryVars(),
                    data: availableSuppliersData,
                  });
                }
              }
            } catch (e) {
              // Cache might not exist yet, that's okay
              console.log("Cache update skipped:", e);
            }
          },
        })
        .then(({ data }) => {
          this.$store.dispatch("showAppSnackbar", { msg: "Service Created." });
          const selectedSupplier = this.selectableSuppliers.find((item) =>
            item.node
              ? item.node.supplierId
                ? item.node.supplierId == this.adhocServiceSupplierId
                : item.node.id == this.adhocServiceSupplierId
              : false
          );
          this.selectedSupplier = selectedSupplier
            ? { ...selectedSupplier.node }
            : this.selectedSupplier;
          // Set selectedService to same shape as cache node so it appears in list and is selected
          const created = data.createService;
          const supplierName =
            (this.selectedSupplier && this.selectedSupplier.supplierName) || "";
          this.selectedService = {
            __typename: "Service",
            id: created.id,
            name: created.name,
            serviceName: created.name,
            serviceId: created.id,
            supplierName,
            supplierId: this.adhocServiceSupplierId,
            priceFrom: null,
            priceFromCurrencyCode: null,
            rateTypeCode: null,
            minOccupancy: created.minOccupancy,
            maxOccupancy: created.maxOccupancy,
            stdOccupancy:
              created.stdOccupancy != null ? created.stdOccupancy : null,
            service: {
              __typename: "ServiceType",
              stdOccupancy:
                created.stdOccupancy != null ? created.stdOccupancy : null,
              code: null,
              imageURL: null,
              description: null,
            },
            prices: [],
          };
          this.newService = { ...data.createService };
          this.loading = false;
        })
        .catch((err) => {
          console.error(err);
          this.loading = false;
        });
    },
    onNewSupplierCreate(payload) {
      this.loading = true;
      this.createAdhocSupplier(payload, (result) => {
        this.$store.dispatch("showAppSnackbar", { msg: "Supplier Created." });
        this.loading = false;
        // Set newly created supplier as selected, using same shape as cache node
        this.showAdhocSupplier = false;
        const created = result.data.createSupplier;
        this.selectedSupplier = {
          __typename: "Supplier",
          id: created.id,
          supplierId: created.id,
          supplierName: created.name,
          headOfficeName: null,
          supplierCode: created.code || "",
          boardBasis: created.boardBasis || "",
          priceFrom: null,
          priceFromCurrencyCode: null,
          imageURL: created.imageURL || "",
          description: created.description || "",
          serviceType: this.selectedSupplierType,
          currencyCode: created.currencyCode || "",
          defaultRateTypeCode: created.defaultRateTypeCode || "",
          extrasChildPrice: created.extrasChildPrice || false,
          availableServices: [],
          name: created.name,
        };
        this.onSupplierChange(this.selectedSupplier);
      });
    },
    onServiceKeyEnter(event) {
      //console.log(this.selectedService, this.serviceSerach, "add new service");
      if (
        !this.selectedService ||
        this.selectedService.name != this.serviceSerach
      ) {
        this.newService = { name: this.serviceSearch };
        this.$refs.serviceAutocomplete.blur();
        this.serviceSearch = "";
        this.selectedService = null;
        this.showAdhocService = true;
      }
    },
    onSupplierKeyEnter(event) {
      if (
        !this.selectedSupplier ||
        this.selectedSupplier.name != this.supplierSearch
      ) {
        this.newSupplierName = this.supplierSearch;
        this.$refs.supplierAutocomplete.blur();
        this.supplierSearch = "";
        this.selectedSupplier = null;
        this.showAdhocSupplier = true;
      }
    },
    setInitialSupplierName() {
      // setTimeout(() => {
      //   this.$refs.supplierAutocomplete.focus();
      //   this.$refs.supplierAutocomplete.$refs.input.value = this.supplierName;
      //   this.$refs.supplierAutocomplete.$refs.input.dispatchEvent(
      //     new Event("input")
      //   );
      //   this.initSupplierName = "";
      // }, 300);
    },
    setInitialServiceName() {
      setTimeout(() => {
        if (this.supplier) {
          // Use availableServicesBySupplier instead of adhocSuppliersList
          const availableSuppliers =
            this.availableServicesBySupplier &&
            this.availableServicesBySupplier.edges
              ? this.availableServicesBySupplier.edges
              : [];
          const preSelectedSupplier = availableSuppliers.find(
            (item) =>
              item.node.id == this.supplier.id ||
              item.node.supplierId == this.supplier.id
          );
          if (preSelectedSupplier) {
            this.selectedSupplier = { ...preSelectedSupplier.node };
            setTimeout(() => {
              this.$refs.serviceAutocomplete.focus();
              this.$refs.serviceAutocomplete.$refs.input.value =
                this.serviceName;
              this.$refs.serviceAutocomplete.$refs.input.dispatchEvent(
                new Event("input")
              );
              this.initServiceName = "";
            }, 200);
          }
        }
      }, 200);
    },
    availableSuppliersQueryVars() {
      return {
        search: {
          destinationId: this.selectedDestinationId,
          agentId: this.agentId,
          startDate: this.startDateOnly,
          endDate: this.endDateOnly,
          serviceType: this.selectedSupplierType,
          adults: this.adults.toString(),
          children: this.children.toString(),
          infants: this.infants.toString(),
          department: this.headerProps.departmentName,
          yearShift:
            Number(this.yearShift) > 0
              ? Number(this.yearShift) * -1
              : Number(this.yearShift),
        },
        filter: {
          supplierNameContains: this.supplierNameFilter,
        },
        first: 50,
        page: 1,
        pageSize: 10,
        includeUnpriced: true,
        skipDetails: false,
        orderBy: undefined,
      };
    },
    createSupplierFromExternalSource() {
      //get supplier details
      this.getExternalSupplierDetails = true;
    },
    createAdhocSupplier(input, cb) {
      this.$apollo
        .mutate({
          mutation: CREATE_ADHOC_SUPPLIER,
          variables: {
            supplierInput: input,
          },
          update: (store, { data: { createSupplier } }) => {
            // Update AVAILABLE_SUPPLIERS_QUERY cache
            try {
              const data = store.readQuery({
                query: AVAILABLE_SUPPLIERS_QUERY,
                variables: this.availableSuppliersQueryVars(),
              });
              if (data && data.availableServicesBySupplier) {
                // Format the new supplier to match availableServicesBySupplier structure
                // Must include all fields the query requests to avoid Apollo cache "Missing field" warnings
                const newSupplierNode = {
                  __typename: "Supplier",
                  id: createSupplier.id,
                  supplierId: createSupplier.id,
                  supplierName: createSupplier.name,
                  headOfficeName: null,
                  supplierCode: createSupplier.code || "",
                  boardBasis: createSupplier.boardBasis || "",
                  priceFrom: null,
                  priceFromCurrencyCode: null,
                  imageURL: createSupplier.imageURL || "",
                  description: createSupplier.description || "",
                  serviceType: this.selectedSupplierType,
                  currencyCode: createSupplier.currencyCode || "",
                  defaultRateTypeCode: createSupplier.defaultRateTypeCode || "",
                  extrasChildPrice: createSupplier.extrasChildPrice || false,
                  availableServices: [],
                };
                const supplierEdge = {
                  node: newSupplierNode,
                  __typename: "SupplierEdge",
                };
                data.availableServicesBySupplier.edges.push(supplierEdge);
                store.writeQuery({
                  query: AVAILABLE_SUPPLIERS_QUERY,
                  variables: this.availableSuppliersQueryVars(),
                  data,
                });
              }
            } catch (e) {
              // Cache might not exist yet, that's okay
              console.log("Cache update skipped:", e);
            }
          },
        })
        .then(cb)
        .catch((err) => {
          console.error(err);
          this.loading = false;
        });
    },
    setSelectedService() {
      if (
        this.selectedService &&
        !this.$apollo.loading &&
        this.selectableServices.length > 0
      ) {
        const selectedService = this.selectableServices.find((item) => {
          // console.log(
          //   item.node ? item.node.priceFrom : "null",
          //   this.selectedService.priceFrom
          // );
          //we need to select proper service if there's more prices for the same service #7223
          return item.node
            ? this.selectedService.priceFrom
              ? item.node.id == this.selectedService.id &&
                item.node.priceFrom == this.selectedService.priceFrom
              : item.node.id == this.selectedService.id
            : false;
        });
        if (selectedService) {
          this.selectedService = null;
          this.selectedService = { ...selectedService.node };
          //to refetch itemPricing
          //this.customPricing = false;
          this.updateQty();
          if (
            this.selectedSupplierType == "TRAVEL" &&
            this.$store.getters.hasAccessTo("plugins:flights_management")
          ) {
            this.$apollo.queries.flight.refetch();
          }
        }
      }
    },
  },

  apollo: {
    serviceInfo: {
      query: SERVICE_INFO,
      variables() {
        return {
          id: this.selectedService.id,
        };
      },
      skip() {
        return !this.selectedService || !this.show;
      },
      fetchPolicy: "network-only",
      result(result) {
        //console.log("service info", result);
        // only if the the current value is  empty
        //https://tracker.globetrack.ie/issues/10437
        if (
          this.remarks.pickupPoint &&
          this.remarks.pickupPoint.toString() == ""
        ) {
          //console.log("pickupPoint", result.data.serviceInfo.pickupPoint);
          this.remarks.pickupPoint =
            result.data.serviceInfo.pickupPoint &&
            result.data.serviceInfo.pickupPoint.toString() != ""
              ? result.data.serviceInfo.pickupPoint
              : "";
        }
        if (
          this.remarks.dropoffPoint &&
          this.remarks.dropoffPoint.toString() == ""
        ) {
          //console.log("dropoffPoint", result.data.serviceInfo.dropoffPoint);
          this.remarks.dropoffPoint =
            result.data.serviceInfo.dropoffPoint &&
            result.data.serviceInfo.dropoffPoint.toString() != ""
              ? result.data.serviceInfo.dropoffPoint
              : "";
        }
        if (
          this.remarks.pickupTime &&
          this.remarks.pickupTime.toString() == ""
        ) {
          //console.log("pickupTime", result.data.serviceInfo.pickupTime);
          this.remarks.pickupTime =
            result.data.serviceInfo.pickupTime &&
            result.data.serviceInfo.pickupTime.toString() != ""
              ? result.data.serviceInfo.pickupTime
              : "";
        }
        if (
          this.remarks.dropoffTime &&
          this.remarks.dropoffTime.toString() == ""
        ) {
          //console.log("dropoffTime", result.data.serviceInfo.dropoffTime);
          this.remarks.dropoffTime =
            result.data.serviceInfo.dropoffTime &&
            result.data.serviceInfo.dropoffTime.toString() != ""
              ? result.data.serviceInfo.dropoffTime
              : "";
        }
      },
    },
    serviceNotes: {
      query: SERVICE_NOTES,
      variables() {
        return {
          filter: {
            serviceId: this.selectedService.id,
            from: this.startDate,
            to: this.endDate,
            department: this.headerProps.departmentName,
            agentId: this.agentId,
          },
        };
      },
      skip() {
        return (
          !this.selectedService ||
          !this.show ||
          this.selectedService.__typename != "AvailableService"
        );
      },
      fetchPolicy: "network-only",
    },
    flight: {
      query: FLIGHT_LOOKUP,
      variables() {
        return {
          serviceId: this.selectedService.id,
          date: this.startDate,
        };
      },
      skip() {
        return (
          !this.selectedService ||
          !this.show ||
          this.selectedSupplierType != "TRAVEL" ||
          !this.$store.getters.hasAccessTo("plugins:flights_management")
        );
      },
      fetchPolicy: "network-only",
      result(result) {
        if (!result.error && result.data && result.data.flight) {
          this.flightErrorMsg = "";
          this.remarks.pickupPoint = result.data.flight.departurePoint;
          this.remarks.dropoffPoint = result.data.flight.arrivalPoint;
          this.remarks.pickupTime = result.data.flight.departureTime;
          this.remarks.dropoffTime = result.data.flight.arrivalTime;
          this.remarks.flightNo = result.data.flight.flightNo;
        }
      },
      error(error) {
        this.flightErrorMsg = error.graphQLErrors
          .map((e) => e.message)
          .join(", ");
      },
    },
    businessModels: {
      query: BUSINESS_MODELS,
      skip() {
        return !this.show;
      },
    },
    // exchangeRates: {
    //   query: ALL_EXCHANGE_RATES_SEARCH_QUERY,
    //   skip() {
    //     return !this.show;
    //   },
    // },
    currencies: {
      query: ALL_CURRENCIES_SEARCH_QUERY,
      variables() {
        return {
          includeExchangeRate: true,
        };
      },
      fetchPolicy: "network-only",
      skip() {
        return !this.show;
      },
    },
    serviceTypes: {
      query: SERVICE_TYPES_QUERY,
      variables() {
        return {
          supplierType: this.selectedSupplierType,
        };
      },

      skip() {
        return !this.show;
      },
      error(error) {
        console.error(error);
      },
      fetchPolicy: "network-only",
    },
    availableServicesBySupplier: {
      query: AVAILABLE_SUPPLIERS_QUERY,
      variables() {
        return {
          search: {
            destinationId: this.selectedDestinationId,
            agentId: this.agentId,
            startDate: this.startDateOnly,
            endDate: this.endDateOnly,
            serviceType: this.selectedSupplierType,
            adults: this.adults.toString(),
            children: this.children.toString(),
            infants: this.infants.toString(),
            department: this.headerProps.departmentName,
            yearShift:
              Number(this.yearShift) > 0
                ? Number(this.yearShift) * -1
                : Number(this.yearShift),
          },
          filter: {
            supplierNameContains: this.supplierNameFilter,
          },
          first: 50,
          page: 1,
          pageSize: 10,
          includeUnpriced: true,
          skipDetails: false,
          orderBy: undefined,
        };
      },
      fetchPolicy: "network-only",
      skip() {
        return !this.show || !this.sfr || !this.headerProps;
      },
    },
    itemPricing: {
      query: GET_PRICE_BREAKDOWN_QUERY,
      variables() {
        this.checkDuration();

        return {
          serviceId: this.selectedService.id,
          agentId: this.agentId,
          department: this.headerProps.departmentName,
          itineraryCreationDate: this.headerProps.createdAt,
          startDate: this.formattedStartDate,
          endDate: this.formattedEndDate,
          adults: Number(this.adults),
          children: Number(this.children),
          infants: Number(this.infants),
          qty: this.numQty,
          ratePlan: this.ratePlan,
          extras: this.extras.map((e) => {
            let qty = e.qty;
            if (e.rateBase == "P") {
              if (e.isChildOnly) {
                qty = e.children;
              } else if (e.isInfantOnly) {
                qty = e.infants;
              } else {
                qty = e.adults;
              }
            }
            return {
              id: e.id,
              qty: Number(qty),
              startDate: e.startDate,
              endDate: e.endDate,
            };
          }),
          yearShift:
            Number(this.yearShift) > 0
              ? Number(this.yearShift) * -1
              : Number(this.yearShift),
        };
      },
      skip() {
        return (
          !(
            this.selectedService &&
            this.selectedService.id &&
            this.selectedService.__typename &&
            this.selectedService.__typename != "ServiceType"
          ) ||
          (this.keepCustomPricingForEdit &&
            this.editItem &&
            this.editItem.customPricing)
        );
      },
      fetchPolicy: "network-only",
      result(result) {
        if (!result.error) {
          this.errorMsg = "";
          const { itemPricing } = result.data;
          //recalculate all to selected currency
          //console.log("selected currency: ", this.currencyExchangeRate);
          //cost
          //this.currencyBuyExRate = itemPricing.currencyBuyExchangeRate;
          //this.currencyBuy = itemPricing.currencyBuy;
          //console.log("got pricing", itemPricing);
          //if (!this.customPricing) {
          const buyExRate = this.safeExchangeRate(
            itemPricing.currencyBuyExchangeRate
          );
          const sellExRate = this.safeExchangeRate(
            itemPricing.currencySellExchangeRate
          );
          const currencyExRate = this.safeExchangeRate(
            this.currencyExchangeRate
          );

          this.itemBuy =
            this.currency != itemPricing.currencyBuy
              ? this.safeNumber(
                  (this.safeNumber(itemPricing.itemBuy) / buyExRate) *
                    currencyExRate
                )
              : this.safeNumber(itemPricing.itemBuy);
          this.adultBuy =
            this.currency != itemPricing.currencyBuy
              ? this.safeNumber(
                  (this.safeNumber(itemPricing.adultBuy) / buyExRate) *
                    currencyExRate
                )
              : this.safeNumber(itemPricing.adultBuy);
          this.childBuy =
            this.currency != itemPricing.currencyBuy
              ? this.safeNumber(
                  (this.safeNumber(itemPricing.childBuy) / buyExRate) *
                    currencyExRate
                )
              : this.safeNumber(itemPricing.childBuy);
          this.infantBuy =
            this.currency != itemPricing.currencyBuy
              ? this.safeNumber(
                  (this.safeNumber(itemPricing.infantBuy) / buyExRate) *
                    currencyExRate
                )
              : this.safeNumber(itemPricing.infantBuy);

          //sell
          // this.currencySell = itemPricing.currencySell;
          // this.currencySellExRate = itemPricing.currencySellExchangeRate;
          this.itemSell =
            this.currency != itemPricing.currencySell
              ? this.safeNumber(
                  (this.safeNumber(itemPricing.itemSell) / sellExRate) *
                    currencyExRate
                )
              : this.safeNumber(itemPricing.itemSell);
          this.adultSell =
            this.currency != itemPricing.currencySell
              ? this.safeNumber(
                  (this.safeNumber(itemPricing.adultSell) / sellExRate) *
                    currencyExRate
                )
              : this.safeNumber(itemPricing.adultSell);
          this.childSell =
            this.currency != itemPricing.currencySell
              ? this.safeNumber(
                  (this.safeNumber(itemPricing.childSell) / sellExRate) *
                    currencyExRate
                )
              : this.safeNumber(itemPricing.childSell);
          this.infantSell =
            this.currency != itemPricing.currencySell
              ? this.safeNumber(
                  (this.safeNumber(itemPricing.infantSell) / sellExRate) *
                    currencyExRate
                )
              : this.safeNumber(itemPricing.infantSell);
          this.rateTypeCode = itemPricing.rateTypeCode;
          this.businessModel = itemPricing.businessModel;
          this.supplierCommission = itemPricing.supplierCommission;

          this.onPriceChange(false);
          this.customPricing = false;
          //}

          //this.resetInputs();
          this.handlePricingMessage();

          if (
            this.errorMsg &&
            !this.lookbackUserDisabled &&
            this.$store.getters.hasAccessTo("itineraries:look_back", true) &&
            this.$store.getters.hasAccessTo("itineraries:lookback_default") &&
            this.yearShift == 0
          ) {
            this.yearShift = 1;
          }
        }
      },
      error(error) {
        //console.log("error", error);
        this.errorMsg = error.graphQLErrors.map((e) => e.message).join(", ");

        if (this.selectedExtras.length == 0) {
          this.resetPricing();
        }
        this.customPricing = true;
        //console.log("custom pricing", this.customPricing);
        //this.updateQty(); //https://tracker.globetrack.ie/issues/7908

        if (
          !this.lookbackUserDisabled &&
          this.$store.getters.hasAccessTo("itineraries:look_back", true) &&
          this.$store.getters.hasAccessTo("itineraries:lookback_default") &&
          this.yearShift == 0
        ) {
          this.yearShift = 1;
        }
      },
    },
    externalSuppliers: {
      client: "gtContent",
      query: GT_CONTENT_HUB_SUPPLIERS,
      skip() {
        return !this.show || !this.loadTravellandaContent;
      },
      variables() {
        return {
          filter: {
            name: this.supplierNameFilter,
            supplierType: this.selectedSupplierType,
          },
        };
      },
    },
    externalSupplierDetails: {
      client: "gtContent",
      query: GT_CONTENT_HUB_SUPPLIER_DETAILS,
      variables() {
        return {
          id: this.selectedSupplier.source.id,
          provider: this.selectedSupplier.source.provider,
        };
      },
      result(result) {
        //console.log("external supplier details", result);
        this.getExternalSupplierDetails = false;
        if (result.data) {
          const external = result.data.externalSupplierDetails;
          const supplier = {
            serviceType: this.selectedSupplierType,
            name: result.data.externalSupplierDetails.name,
            code: result.data.externalSupplierDetails.source.id,
            notes: `${result.data.externalSupplierDetails.source.name}:${result.data.externalSupplierDetails.source.id}`,
            telephone: result.data.externalSupplierDetails.phoneNumber,
            address: result.data.externalSupplierDetails.address,
            contents: [
              ...result.data.externalSupplierDetails.contents.map((c) => ({
                name: c.name,
                description: c.description,
                imgURL: c.imageURL,
              })),
            ],
          };
          this.loading = true;
          this.createAdhocSupplier(supplier, (result) => {
            this.loading = false;
            console.log(
              "set selected supplier",
              result.data.createSupplier.node
            );
            this.selectedSupplier = {
              ...result.data.createSupplier.node,
              name: result.data.createSupplier.node.name,
            };
            this.createNewService();
          });
        }
      },
      skip() {
        return !this.getExternalSupplierDetails;
      },
      error(error) {
        console.warn(error);
      },
    },
  },
};
</script>
<style scoped>
.max-lines {
  display: block; /* or inline-block */
  text-overflow: ellipsis;
  word-wrap: break-word;
  overflow: hidden;
  max-height: 10.2em;
  line-height: 1.8em;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
</style>


// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/tools/AddAdhocItem.vue